import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Trans, useTranslation } from "react-i18next";

import Icon from "src/components-v2/Icon";
import Link from "../Link";

import { colors } from "src/assets/styles/settings";
import privateRoutes from "src/routes/private-routes";

function DepositAutoWithdrawalInactive() {
  const { t } = useTranslation("deposit");

  return (
    <div className="u-bg-main-background u-px-4 u-py-2 md:u-px-8 2xl:u-px-12 u-flex u-gap-4">
      <div>
        <Icon size="1x" color={colors.neutral_secondary_text} icon={faInfoCircle} />
      </div>
      <div className="">
        <div className="u-mb-0 u-font-medium u-text-neutral_main_text">
          <Trans t={t} i18nKey={"overview.banner-deposit-auto-withdrawal.auto-withdrawal-inactive.description"}>
            <span className="u-font-medium" />
          </Trans>
        </div>
        <div className="u-mb-0 u-text-neutral_main_text u-text-semi u-font-medium">
          <Trans t={t} i18nKey={"overview.banner-deposit-auto-withdrawal.auto-withdrawal-inactive.feature"}>
            <Link to={privateRoutes.settingsDeposit.path} />
          </Trans>
        </div>
      </div>
    </div>
  );
}

export default DepositAutoWithdrawalInactive;
